import { aggridFilterConstants } from 'constants/AggridFilter.constants';
import { productConstants } from 'constants/Product.constants';

export function generatePcbTextBlocks(item) {
  const { variable_weight: hasVariableWeight, pcb } = item;
  const list = [];
  if (hasVariableWeight) {
    list.push({
      content: 'Environ',
      isSmall: true,
    });
  }
  list.push({
    content:
      pcb > 1
        ? `${pcb} ${hasVariableWeight ? 'kilos' : 'unités'}`
        : `${pcb} ${hasVariableWeight ? 'kilo' : 'unité'}`,
    isBold: true,
  });
  list.push({
    content: 'par colis',
    isSmall: true,
  });
  return list;
}

export function checkTechnicalSheetAvailability(file) {
  const requestOptions = {
    method: 'GET',
    mode: 'cors',
  };

  return fetch(`https:${file}`, requestOptions)
    .then(() => {
      return true;
    })
    .catch((error) => {
      return false;
    });
}

export function getProductImageFromEan(ean, size) {
  return `https://photos.groupesafo.com/wsse/cb8f190153190ebe8598ac49e86ebf37/${size}/${size}/${ean}`;
}

export function getPcbUnit(item) {
  const { pcb, unit } = item;
  const effectiveUnit = getProductUnit(unit);

  return pcb > 1 ? `${effectiveUnit}s` : effectiveUnit;
}

export function getProductUnit(unit) {
  if (unit === productConstants.UNIT_KILO) {
    return 'kilo';
  }

  return 'unité';
}

export function getProductShortUnit(unit) {
  if (unit === productConstants.UNIT_KILO) {
    return 'kg';
  }

  return 'u';
}

export function getProductType(type) {
  return type === aggridFilterConstants.FILTER_FRESH ? 'frais' : type.toLowerCase();
}

/**
 * Formats contrat_date by removing leading zeros and handling special cases
 * @param {string} contratDate - The contrat_date value to format
 * @returns {string} Formatted date or " - " if empty/invalid
 * @example
 * formatContratDate("1200") => "1200"
 * formatContratDate("0120") => "120"
 * formatContratDate("0090") => "90"
 * formatContratDate("0001") => "1"
 * formatContratDate("0000") => " - "
 */
export function getPromotionFields(item) {
  const p = item.promotion;
  if (!p) {
    return {};
  }
  return {
    id: p.id,
    price: p.price,
    promo_code: p.promo_code,
    display_as_promotion: p.display_as_promotion,
    stock_commitment_remaining: p.stock_commitment_remaining,
    stock_commitment_request: p.stock_commitment_request,
    stock_commitment: p.stock_commitment,
    has_requested_commitment: p.has_requested_commitment,
  };
}

export function formatContratDate(contratDate) {
  // If contrat_date is empty, null, or "0000", return "-"
  if (!contratDate || contratDate === '' || contratDate === '0000') {
    return ' - ';
  }

  // Remove leading zeros by converting to number and back to string
  // This handles: "1200" => "1200", "0120" => "120", "0090" => "90", "0001" => "1"
  const formatted = String(Number(contratDate));

  // If the result is "0" or "NaN" (invalid number), return "-"
  if (formatted === '0' || formatted === 'NaN') {
    return ' - ';
  }

  return formatted;
}
